import { ReactComponent as HomeIcon } from "../../assets/home.svg";
import { ReactComponent as HomeIconHover } from "../../assets/homeHover.svg";

import { ReactComponent as SimulationIcon } from "../../assets/simulacao.svg";
import { ReactComponent as SimulationIconHover } from "../../assets/simulacaoHover.svg";

import { ReactComponent as CargasIcon } from "../../assets/cargas.svg";
import { ReactComponent as CargasIconHover } from "../../assets/cargasHover.svg";

import { ReactComponent as PedidosIcon } from "../../assets/pedidos.svg";
import { ReactComponent as PedidosIconHover } from "../../assets/pedidosHover.svg";

import { ReactComponent as CalendarioIcon } from "../../assets/calendario.svg";
import { ReactComponent as CalendarioIconHover } from "../../assets/calendarioHover.svg";
import { ReactComponent as ProductIcon } from "../../assets/productIcon.svg";

const navItems = [
  {
    name: "Início",
    path: "/dashboard",
    icon: HomeIcon,
    iconHover: HomeIconHover,
    subItems: [{ name: "Configurações", path: "/configuraçoes" }],
  },
  {
    name: "Produtos",
    path: "/produtos",
    icon: ProductIcon, //TODO: alterar ícone
    iconHover: ProductIcon,
  },
  {
    name: "Pedidos",
    path: "/pedidos",
    icon: PedidosIcon,
    iconHover: PedidosIconHover,
    subItems: [
      { name: "Novo Pedido", path: "/novo-pedido" },
      { name: "Detalhes do Pedidos", path: "/detalhes" },
    ],
  },
  {
    name: "Cargas",
    path: "/cargas",
    icon: CargasIcon,
    iconHover: CargasIconHover,
    subItems: [
      { name: "Nova Carga", path: "/nova-carga" },
      { name: "Detalhes da Carga", path: "/detalhes" },
    ],
  },
  {
    name: "Pagamentos",
    path: "/pagamentos",
    icon: CargasIcon,
    iconHover: CargasIconHover,
  },
  {
    name: "Simulações",
    path: "/simulacoes",
    icon: SimulationIcon,
    iconHover: SimulationIconHover,
  },
  {
    name: "Calendário",
    path: "/calendario",
    icon: CalendarioIcon,
    iconHover: CalendarioIconHover,
  },
  {
    name: "Calculadora",
    path: "/calculadora",
    icon: CalendarioIcon,
    iconHover: CalendarioIconHover,
  },
];

export default navItems;
